import React, { useContext } from 'react';
import Rupee from '../../../Assets/Modals/RupeeGray.svg';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import { sanitizeToPositiveInteger } from '../../../lib/utils/utils';

function SetFixedPrice() {
    const { formInputs, setFormInputs, formErrors } = useContext(AddCouponFormContext);

    const handleChange = (e) => {
        const {name, value} = e.target;
        const cleanedValue = sanitizeToPositiveInteger(value);
        setFormInputs({ ...formInputs, [name]: cleanedValue });
    };

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Set Offer Value</h1>

                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.fixedPrice}</p>
            </div>

            <div className="flex items-center gap-3">
                <label htmlFor="fixed-price" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer'>Fixed Discount</label>

                <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg w-[200px] h-14 flex items-center gap-2 focus-within:border-primaryColor">
                    <div className="size-6 flex items-center justify-center">
                        <img src={Rupee} alt="" />
                    </div>

                    <input 
                        className='w-[calc(100%-24px)] bg-transparent outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666]' 
                        type="text" 
                        placeholder='0' 
                        id='fixed-price' 
                        name='fixedPrice' 
                        value={formInputs.fixedPrice} 
                        onChange={handleChange} 
                    />
                </div>
            </div>
        </div>
    );
}

export default SetFixedPrice;
